export const hotTopics = [
  { rank: 1, title: '苏晚棠深夜长文回应合作解约风波', heat: '986万', tag: '持续发酵', trend: 'up' },
  { rank: 2, title: '陈牧远工作室被曝关联多家空壳公司', heat: '851万', tag: '新增线索', trend: 'up' },
  { rank: 3, title: '林知夏综艺现场改剧本传闻整理', heat: '722万', tag: '待核实', trend: 'flat' },
  { rank: 4, title: '顾时予旧采访片段被重新剪辑传播', heat: '640万', tag: '二次讨论', trend: 'up' },
  { rank: 5, title: '综艺《长夜班》选手投票数据异常盘点', heat: '588万', tag: '有争议', trend: 'down' },
  { rank: 6, title: '温辞新剧番位变动前后时间线梳理', heat: '512万', tag: '时间线', trend: 'flat' },
  { rank: 7, title: '江枕月代言品牌方悄悄撤换物料', heat: '463万', tag: '品牌动态', trend: 'down' },
  { rank: 8, title: '短剧演员沈砚账号异常涨粉记录', heat: '401万', tag: '数据观察', trend: 'up' },
  { rank: 9, title: '音乐节压轴替换事件双方声明对照', heat: '352万', tag: '双方发声', trend: 'flat' },
  { rank: 10, title: '柳玄霜直播口误引发的话题连锁反应', heat: '318万', tag: '新话题', trend: 'up' },
];

export const heatDistribution = [
  { label: '解约与合约纠纷', value: 92 },
  { label: '作品番位与资源', value: 74 },
  { label: '商业代言变动', value: 63 },
  { label: '数据与流量异常', value: 55 },
  { label: '综艺现场传闻', value: 41 },
];

export const featuredEvents = [
  {
    id: 1,
    category: '合约纠纷',
    title: '解约文件前后对照：从合作公告到声明的时间线',
    summary: '把公开可见的合作公告、品牌物料与本人声明按时间排序，一条线看清事件如何一步步走到今天。',
    date: '09-11',
    views: '12.6万',
    tags: ['时间线', '文件对照'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20stage%20spotlight%20with%20geometric%20light%20beams%20on%20soft%20cream%20background%2C%20minimal%20editorial%20illustration%2C%20layered%20paper%20shapes%2C%20terracotta%20and%20ochre%20palette%2C%20clean%20composition%2C%20subtle%20grain%20texture%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=800&height=520&seq=heliao-card-01&orientation=landscape',
  },
  {
    id: 2,
    category: '资源变动',
    title: '番位与物料撤换：一场新剧宣传期的静默调整',
    summary: '从海报排序、预告片镜头到官微文案，整理出这轮调整中所有可被公开观察到的细节。',
    date: '09-09',
    views: '9.8万',
    tags: ['物料对比', '官微记录'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20soft%20terracotta%20folding%20theater%20screen%20silhouette%20with%20warm%20geometric%20shapes%20on%20cream%20background%2C%20minimal%20editorial%20illustration%2C%20muted%20amber%20accents%2C%20clean%20negative%20space%2C%20subtle%20paper%20texture%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=800&height=520&seq=heliao-card-02&orientation=landscape',
  },
  {
    id: 3,
    category: '数据观察',
    title: '涨粉曲线异常：几组被反复截图的账号数据',
    summary: '把争议中出现的几组粉丝增长截图重新核对时间与区间，标注哪些是重合、哪些对不上。',
    date: '09-07',
    views: '7.4万',
    tags: ['数据截图', '区间核对'],
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20amber%20camera%20lens%20aperture%20geometric%20shape%20on%20warm%20cream%20background%2C%20minimal%20editorial%20illustration%2C%20concentric%20circles%2C%20ochre%20and%20rust%20palette%2C%20clean%20composition%2C%20subtle%20grain%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=800&height=520&seq=heliao-card-03&orientation=landscape',
  },
];

export const directories = [
  { name: '合约与解约', count: 128, icon: 'ri-file-paper-2-line', desc: '公告、声明、合约变更' },
  { name: '作品与番位', count: 96, icon: 'ri-film-line', desc: '剧集、综艺、番位调整' },
  { name: '商业代言', count: 74, icon: 'ri-store-2-line', desc: '品牌官宣与物料变动' },
  { name: '数据与流量', count: 63, icon: 'ri-line-chart-line', desc: '涨粉、播放、投票数据' },
  { name: '现场与传闻', count: 52, icon: 'ri-mic-line', desc: '综艺现场、活动记录' },
  { name: '社交动态', count: 141, icon: 'ri-chat-3-line', desc: '发文、互动、旧帖重提' },
  { name: '时间线梳理', count: 38, icon: 'ri-timeline-view', desc: '事件前后完整脉络' },
  { name: '声明与回应', count: 45, icon: 'ri-megaphone-line', desc: '双方发文与回应整理' },
];

export const weeklyRoundup = [
  { date: '09-12', title: '苏晚棠合作方撤换首页物料', type: '已核实', status: 'brand', heat: 96 },
  { date: '09-12', title: '陈牧远工作室关联公司名单更新', type: '新增线索', status: 'new', heat: 88 },
  { date: '09-11', title: '长夜班节目组就投票数据发布说明', type: '双方发声', status: 'statement', heat: 84 },
  { date: '09-11', title: '林知夏改剧本传闻出现不同版本录音', type: '待核实', status: 'pending', heat: 79 },
  { date: '09-10', title: '温辞新剧官微重新调整宣传顺序', type: '已核实', status: 'brand', heat: 72 },
  { date: '09-10', title: '顾时予旧采访片段被多平台重剪', type: '二次讨论', status: 'new', heat: 68 },
  { date: '09-09', title: '音乐节压轴替换双方声明对照整理', type: '双方发声', status: 'statement', heat: 61 },
  { date: '09-09', title: '江枕月代言页面悄悄下架相关画面', type: '已核实', status: 'brand', heat: 55 },
];

export const siteStats = [
  { value: '1,284', label: '收录条目', unit: '条' },
  { value: '86', label: '今日更新', unit: '条' },
  { value: '37', label: '进行中话题', unit: '个' },
  { value: '10', label: '热度榜位', unit: '位' },
];